import React, { useState, useEffect } from "react";
import Filters from "components/common/Filters";
import { Popup } from "devextreme-react";
import Api from "Api/Api";
import Utils from "Utils";
import { connect } from "react-redux";
import { navigate } from "@reach/router";
import DataGrid, { Column } from "devextreme-react/data-grid";
import { TextBox } from "devextreme-react";
import Paginator from "components/common/Paginator";
import moment from "moment";
import Reminders from "components/AdminComponents/Reminders";
import { StartupInvestmentDetails } from "components/forms/InvestmentDetails";
import { StartupCrud } from "components/forms/StartupCrud";
import { useUrlFilter } from "Hooks/utils";
import { isAllowed } from "permissions/index";
import { Permissions } from "permissions/constants";
import { DeleteModal } from "components/common/DeleteModal";

function AdminLanding(props) {
  const { dispatch, formFields } = props;

  const [data, setData] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [startupToSend, setStartupToSend] = useState(null);
  const [popupType, setPopupType] = useState(null);
  const [count, setCount] = useState(0);
  const [filters, setFilters] = useUrlFilter();
  const [openStartupForm, setOpenStartupForm] = useState(false)
  const [dataOfStartupToEdit, setDataOfStartupToEdit] = useState(null)
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [startupToBeDeleted, setStartupToBeDeleted] = useState(null)

  useEffect(() => {
    Utils.getFormFields();
    dispatch({
      type: "SectionSelected",
      payload: "Startups",
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (filters) {
      const page = filters?.page;
      delete filters?.page;
      loadData(page, filters);
    }
  }, [filters]); // eslint-disable-line react-hooks/exhaustive-deps

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };
  const setReminder = (startup_id) => {
    setStartupToSend(startup_id);
    setPopupType("reminder");
    togglePopup();
  };
  const startupUpdated = (record) => {
    if (isAllowed(Permissions.UPDATE_STARTUP)) {
      var data = Utils.formNewDataDevXDatagrid(record.newData, record.oldData);
      Api.updateStartupData(record.key.id, data).then((response) => {
        if (response.status === 400) {
          Utils.notify(
            Utils.errorMessageGenerator(response.data),
            "warning",
            4000
          );
          record.cancel = true;
          record.component.cancelEditData();
        } else if (response.status === 200) {
          Utils.notify("Startup updated successfully!", "success", 4000);
        }
      });
    } else {
      Utils.notify(
        "You are not allowed to perform this action",
        "warning",
        4000
      );
    }
  };
  const toolbarPreparing = (e) => {
    let toolbarItems = e.toolbarOptions.items;
    toolbarItems.push({
      widget: "dxButton",
      options: {
        text: "* Purples are inactive startups",
        stylingMode: "text",
        hoverStateEnabled: false,
      },
      location: "before",
    });
    if (isAllowed(Permissions.ADD_STARTUP)) {
      toolbarItems.push({
        widget: "dxButton",
        options: {
          text: "+",
          onClick: () => { setOpenStartupForm(true) }
        },
        location: "after",
      })
    }
  };
  const preparingRow = (row) => {
    if (row.rowType === "data" && row.data.active === "inactive") {
      row.rowElement.style.backgroundColor = "#f5b8ff";
    }
  };
  const startupAdded = (record) => {
    Api.createStartup(record.data).then((response) => {
      if (response.status === 200) {
        setData([...data, response.data]);
      } else if (response.status === 400) {
        Utils.notify(
          Utils.errorMessageGenerator(response.data),
          "warning",
          4000
        );
      } else if (response.status === 200) {
        Utils.notify("Startup created successfully!", "success", 4000);
      }
    });
  };
  const startupRemoved = async (startupData) => {
    const response = await Api.deleteStartup(startupData.id);
    if (response.status !== 200) {
      Utils.notify(
        Utils.errorMessageGenerator(response.data),
        "warning",
        4000
      );
    } else {
      const updatedListOfStartups = [...data].filter(startup => {
        return startup.id !== startupData.id;
      });
      setData(updatedListOfStartups);
      Utils.notify("Startup deleted successfully!", "success", 4000);
    }
  };
  const customExport = (excel) => {
    excel.fileName = `Startup's Data-${moment(new Date()).format("ll")}`;
    excel.component.beginUpdate();
    excel.component.columnOption("id", "visible", true);
    excel.component.columnOption("business_description", "visible", true);
    excel.component.columnOption("mobile_number", "visible", true);
    // excel.component.columnOption("ask_amount", "visible", true);
    excel.component.columnOption("lead_source", "visible", true);
    excel.component.columnOption("comment_box", "visible", true);
    excel.component.columnOption("founder_email", "visible", true);
    excel.component.columnOption("created", "visible", true);
    excel.component.columnOption("website", "visible", true);
    excel.component.columnOption("valuation", "visible", true);
  };
  const renderComponent = () => {
    switch (popupType) {
      case "reminder":
        return (
          <Reminders
            id={startupToSend}
            type={"startup"}
            popupHidden={togglePopup}
          />
        );
      default:
        break;
    }
  };
  const rowClicked = (startupID) => {
    navigate(`/startup/${startupID}`);
  };
  const chatSearch = (e) => {
    if (e.value !== "") {
      Api.searchChats(e.value).then((response) => {
        if (response.status === 200) {
          setData(response.data.results);
          setCount(response.data.count);
        }
      });
    } else {
      loadData();
    }
  };

  const loadData = (page = 1, filters) => {
    dispatch({ type: "toggleLoad" });
    Api.getAllStartups(page, filters).then((response) => {
      dispatch({
        type: "toggleLoad",
      });
      if (response.status === 200) {
        setData(response.data.results);
        setCount(response.data.count);
      } else if (response.status === 404) {
        setFilters({ page: 1 });
      }
    });
  };

  const submitHandler = (payload, created) => {
    if (created) {
      setData([...data, payload]);
    } else {
      const updatedData = [...data].map(startup => {
        return startup.id === payload.id ? payload : startup
      })
      setData(updatedData);
    }
  }

  const headers = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (startupName, record) => {
        return <>
          {startupName}{" "}
          <span
            className={`badge badge-pill ${record.reminder_active
              ? "badge-success"
              : "badge-warning"
              }`}
            title={record.reminder}
          >
            <i
              className="material-icons pointer"
              style={{ fontSize: 14 }}
              onClick={() => setReminder(record.id)}
            >
              add_alert
            </i>
          </span>
        </>
      }
    },
    {
      title: 'Founder Name',
      dataIndex: 'founder_first_name',
      key: 'founder_first_name',
      render: (_, record) => <div>{`${record.founder_first_name} ${record.founder_last_name}`}</div>,
    },
    {
      title: 'Current Status',
      dataIndex: 'current_status',
      key: 'current_status',
    },
    {
      title: 'Industry',
      dataIndex: 'industry',
      key: 'industry',
    },
    {
      title: 'Segment',
      dataIndex: 'segment',
      key: 'segment',
    },
    {
      title: 'Stage',
      dataIndex: 'stage',
      key: 'stage',
    },
    {
      title: 'Sector',
      dataIndex: 'sector',
      key: 'sector',
    },
    {
      title: 'City',
      dataIndex: 'city',
      key: 'city',
    },
    {
      title: 'Ask amount',
      dataIndex: 'ask_amount',
    },
    {
      title: '',
      render: (_, row) => {
        return (
          <span
            className="badge badge-pill badge-success pointer"
            onClick={() => navigate(`/match/${row.id}`)}
          >
            Send to investor
          </span>
        );
      }
    },
    {
      title: '',
      render: (_, row) => {
        return (
          <span
            className="badge badge-pill badge-warning pointer"
            onClick={() => setStartupToSend(row.id)}
          >
            Investment Details
          </span>
        );
      }
    },
    {
      title: '',
      render: (_, row) => {
        return (
          <span
            className="badge badge-pill badge-info pointer"
            onClick={() => rowClicked(row.id)}
          >
            Tracker
          </span>
        );
      }
    },
    {
      title: '',
      render: () => {
        return (
          <span
            className="flex gap-10 table-actions"
          >
            <img src="/logos/edit.png" alt="edit" />
            <img src="/logos/delete.png" alt="delete" />
          </span>
        );
      }
    },
  ]

  return (
    <div className="row">
      <div className="col-lg-12">
        <Filters type="startup" />
        <div className="card">
          <div className="card-header card-header-success">
            <div className="ct-chart" id="completedTasksChart">
              <div className="row">
                <div className="col-lg-9">
                  <div style={{ textTransform: "capitalize" }}>
                    <h4>Startups</h4>
                  </div>
                </div>
                <div className="col-lg-3">
                  <TextBox
                    placeholder="Search Chats..."
                    mode="search"
                    onValueChanged={chatSearch}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="card-body">
            {/* <div>* Purples are inactive startups</div> */}
            {/* <AntTable
              headers={headers}
              data={data}
              options={{
                pagination: false,
                rowClassName: (row) => (row.active === "active" ? "" : "inactiveRow")
              }}
            /> */}
            <DataGrid
              dataSource={data}
              export={{ enabled: isAllowed(Permissions.EXPORT_STARTUP) }}
              onExporting={customExport}
              wordWrapEnabled={true}
              hoverStateEnabled={true}
              onRowInserting={startupAdded}
              onRowPrepared={preparingRow}
              onToolbarPreparing={toolbarPreparing}
              onRowRemoved={startupRemoved}
              onRowUpdating={startupUpdated}
            >
              <Column dataField="id" visible={false} />
              <Column
                dataField="name"
                allowSorting={false}
                cellRender={(e) => {
                  return (
                    <>
                      {e.row.data.name}{" "}
                      <span
                        className={`badge badge-pill ${e.row.data.reminder_active
                          ? "badge-success"
                          : "badge-warning"
                          }`}
                        title={e.row.data.reminder}
                      >
                        <i
                          className="material-icons pointer"
                          style={{ fontSize: 14 }}
                          onClick={() => setReminder(e.row.data.id)}
                        >
                          add_alert
                        </i>
                      </span>
                    </>
                  );
                }}
              />
              <Column dataField="founder_first_name" allowSorting={false} />
              <Column dataField="founder_last_name" allowSorting={false} />
              <Column dataField="founder_email" visible={false} />
              <Column dataField="current_status" allowSorting={false} />
              <Column dataField="industry" allowSorting={false} />
              <Column dataField="segment" allowSorting={false} />
              <Column dataField="stage" allowSorting={false} />
              <Column dataField="sector" allowSorting={false} />
              <Column dataField="valuation" visible={false} />
              <Column dataField="active" visible={false} />
              <Column dataField="business_description" visible={false} />
              <Column dataField="mobile_number" visible={false} />
              <Column dataField="city" allowSorting={false} />
              <Column dataField="country" visible={false} />
              <Column dataField="deal_type" visible={false} />
              <Column dataField="ask_amount" allowSorting={false} />
              <Column dataField="lead_source" visible={false} />
              <Column dataField="website" visible={false} />
              <Column dataField="comment_box" visible={false} />
              <Column dataField="reminder_date" visible={false} />
              <Column dataField="reminder" visible={false} />
              <Column
                width={106}
                alignment="center"
                cellRender={(row) => {
                  return (
                    <span
                      className="badge badge-pill badge-success pointer"
                      onClick={() => navigate(`/match/${row.data.id}`)}
                    >
                      Send to investor
                    </span>
                  );
                }}
              />
              <Column
                width={106}
                alignment="center"
                cellRender={(row) => {
                  return (
                    <span
                      className="badge badge-pill badge-warning pointer"
                      onClick={() => setStartupToSend(row.data.id)}
                    >
                      Investment Details
                    </span>
                  );
                }}
              />
              <Column
                alignment="center"
                cellRender={(row) => {
                  return (
                    <span
                      className="badge badge-pill badge-info pointer"
                      onClick={() => rowClicked(row.data.id)}
                    >
                      Tracker
                    </span>
                  );
                }}
              />
              <Column
                alignment="center"
                cellRender={(row) => {
                  return (
                    <span
                      className="action-img flex gap-10"
                    >
                      <img src="/logos/edit.png" alt="pencil-icon" onClick={() => {
                        setDataOfStartupToEdit(row.data)
                        setOpenStartupForm(true)
                      }} />
                      {isAllowed(Permissions.DELETE_STARTUP) && <img src="/logos/delete.png" alt="trash-icon" onClick={() => {
                        setDeleteModalVisible(true);
                        setStartupToBeDeleted(row.data);
                      }} />}

                    </span>
                  );
                }}
              />
            </DataGrid>
            <Paginator totalItemsCount={count} pageRangeDisplayed={5} />
            <Popup
              visible={showPopup}
              onHiding={togglePopup}
              closeOnOutsideClick={true}
              contentComponent={renderComponent}
            />
          </div>
        </div>
      </div>

      <StartupInvestmentDetails
        id={startupToSend}
        onClose={() => setStartupToSend(null)}
        dynamicFields={formFields}
      />
      <StartupCrud
        onClose={() => {
          setOpenStartupForm(false)
          setDataOfStartupToEdit(null);
        }}
        visible={openStartupForm}
        dynamicFields={formFields}
        data={dataOfStartupToEdit}
        onSubmit={submitHandler}
      />
      <DeleteModal
        title={"Delete startup?"}
        subheading={`Do you want to delete this startup ${startupToBeDeleted?.name}?`}
        isOpen={deleteModalVisible}
        onCancel={() => {
          setDeleteModalVisible(false);
          setStartupToBeDeleted(null);
        }}
        onOk={async () => {
          await startupRemoved(startupToBeDeleted);
          setDeleteModalVisible(false);
        }}
      />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    section: state.section,
    formFields: state.formFields,
  };
}

export default connect(mapStateToProps)(AdminLanding);
